/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.body.addEventListener('click', ev => {
    if(ev.target.classList.contains('link--more')) {
        ev.preventDefault();
        const btn = ev.target;
        const box = ev.target.closest('.product-meta__description');
		const buybox = box.closest('.product-block-list__item--buybox');
		const wrapper = buybox.closest('.product-block-list');
		
        box.classList.toggle('product-meta__description--collapsed');
	    wrapper.style.setProperty('min-height', `${buybox.offsetHeight}px`);
        if(box.classList.contains('product-meta__description--collapsed')) { 
            btn.innerText = 'Read more';
        } else {
            btn.innerText = 'Show less';
        }
      	
    }
});

$(".slider-wrapper").flickity({
  wrapAround: true,
  pageDots: false,
  initialIndex: 1,
  cellAlign: 'left'
});


let getSticky = document.querySelector('.Quick_Links .section');
if(getSticky){
  let getStickyAttribute = getSticky.getAttribute('data-sticky-enable');
  if(getStickyAttribute=='true'){
    document.querySelector('.Quick_Links').classList.add('Sticky_Links');
  } 
}